import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { List, LayoutGrid } from 'lucide-react';
import { Button } from '../ui/button';

interface IssuesHeaderProps {
  onSearch: (searchTerm: string) => void;
  onFilter: (filter: string) => void;
  onViewChange: (view: 'table' | 'card') => void;
  currentView: 'table' | 'card';
}

const IssuesHeader: React.FC<IssuesHeaderProps> = ({
  onSearch,
  onFilter,
  onViewChange,
  currentView,
}) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState(searchParams.get('q') || '');

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    onSearch(event.target.value);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams();
    if (searchQuery) {
      queryParams.set('q', searchQuery);
    }
    navigate({ search: queryParams.toString() });
  }, [searchQuery, navigate]);

  // const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
  //   onFilter(event.target.value);
  // };

  return (
    <div className="issues-header flex items-center justify-end gap-4">
      <div className="relative">
        <input
          type="text"
          placeholder="Search issues..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="px-4 py-2 text-orange-200 text-size-lg bg-gray-800 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 w-[300px] border border-gray-800" // Add border border-gray-800
        />
        {searchQuery && (
          <button
            onClick={() =>
              handleSearchChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>)
            }
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            ×
          </button>
        )}
      </div>
      <div className="header-spacer"></div>
      {/* <select
        onChange={handleFilterChange}
        className="px-4 py-2 bg-gray-800 border rounded-lg"
      >
        <option value="">All</option>
        <option value="status">By Status</option>
      </select> */}

      <div className="flex items-center space-x-2">
        <Button
          variant={currentView === 'table' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('table')}
        >
          <div className="flex items-center align-middle space-x-2 py-1">
            <List className="h-4 w-4" />
            <span className="hidden sm:inline">Table</span>
          </div>
        </Button>

        <Button
          variant={currentView === 'card' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('card')}
        >
          <div className="flex items-center align-middle space-x-2 py-1">
            <LayoutGrid className="h-4 w-4" />
            <span className="hidden sm:inline">Cards</span>
          </div>
        </Button>
      </div>
    </div>
  );
};

export default IssuesHeader;
